import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** hamburger menu. Decorative line icon; always pair with a visible text label. */
export function MenuIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M4 7h16" />
      <path d="M4 12h16" />
      <path d="M4 17h16" />
    </IconSvg>
  )
}
